import { createCommand } from '@atlassian/rovo-content-bridge-api';

/**
 * Data payload for updating a Confluence page.
 */

/**
 * Properties for the Confluence update creation command.
 *
 * @extends CommandProperties
 */

/**
 * A command sent by a bridge API client to update a Confluence page.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to create a Confluence page with the specified content.
 */
export var ConfluenceUpdatePageCommand = createCommand('confluence-page-update-command');